<template>
    <div class="card-body">
        <h5>{{ title }}</h5>
        <div class="row" style="text-align: left;vertical-align: center;margin-top:30px">
            <div class="col-3"><h5>{{ subTitle.a }}</h5></div>
            <div class="col-4"><h5>{{ getData.product }}</h5></div>
            <div class="col-5">
                <h5 v-if="getDataLastMon.product <= 0">
                    {{ getData.product }}&nbsp;%
                    <span><i class="bi bi-arrow-up-square-fill" style="color: green"></i></span>
                </h5>
                <h5 v-else>
                    {{ calReturn2Decimal((getData.product-getDataLastMon.product)/getDataLastMon.product) }}&nbsp;%
                    <span v-if="(getData.product-getDataLastMon.product)/getDataLastMon.product < 0">
                        <i class="bi bi-arrow-down-square-fill" style="color: red"></i>
                    </span>
                    <span v-else>
                        <i class="bi bi-arrow-up-square-fill" style="color: green"></i>
                    </span>
                </h5>
            </div>
        </div>
        <div class="row" style="text-align: left;vertical-align: center">
            <div class="col-3"><h5>{{ subTitle.b }}</h5></div>
            <div class="col-4"><h5>{{ getData.key }}</h5></div>
            <div class="col-5">
                <h5 v-if="getDataLastMon.key <= 0">
                    {{ getData.key }}&nbsp;%
                    <span><i class="bi bi-arrow-up-square-fill" style="color: green"></i></span>
                </h5>
                <h5 v-else>
                    {{ calReturn2Decimal((getData.key-getDataLastMon.key)/getDataLastMon.key) }}&nbsp;%
                    <span v-if="(getData.key-getDataLastMon.key)/getDataLastMon.key < 0">
                        <i class="bi bi-arrow-down-square-fill" style="color: red"></i>
                    </span>
                    <span v-else>
                        <i class="bi bi-arrow-up-square-fill" style="color: green"></i>
                    </span>
                </h5>
            </div>
        </div>
        <div class="row" style="text-align: left;vertical-align: center">
            <div class="col-3"><h5>{{ subTitle.c }}</h5></div>
            <div class="col-4"><h5>{{ getData.sumQty }}</h5></div>
            <div class="col-5">
                <h5 v-if="getDataLastMon.sumQty <= 0">
                    {{ getData.sumQty }}&nbsp;%
                    <span><i class="bi bi-arrow-up-square-fill" style="color: green"></i></span>
                </h5>
                <h5 v-else>
                    {{ calReturn2Decimal((getData.sumQty-getDataLastMon.sumQty)/getDataLastMon.sumQty) }}&nbsp;%
                    <span v-if="(getData.sumQty-getDataLastMon.sumQty)/getDataLastMon.sumQty < 0">
                        <i class="bi bi-arrow-down-square-fill" style="color: red"></i>
                    </span>
                    <span v-else>
                        <i class="bi bi-arrow-up-square-fill" style="color: green"></i>
                    </span>
                </h5>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TopChartBox",
    props: {
        title: '',
        getData: [],
        getDataLastMon: [],
        subTitle: [],
    },
    methods: {
        calReturn2Decimal(value){
            // * 100 => 100%, *10 get one more decimal
            return Math.round(value*100*10)/10
        }
    }
}
</script>

<style scoped>

</style>
